export default "__VITE_ASSET__C4D3DMFw__"